
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const authenticateUser = (loginRequest) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders('')
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Authentication/AuthenticateUser`, JSON.stringify(loginRequest), headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const changePassword = (changePasswordRequest) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders('')
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Authentication/ChangePassword`, JSON.stringify(changePasswordRequest), headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const acceptPartnerEula = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Authentication/AcceptPartnerEula`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const AuthenticationService =
{
	authenticateUser,
	changePassword,
	acceptPartnerEula
}

export default AuthenticationService
